import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { Label } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const TagNode = memo(({ id, data, isConnectable, selected }) => {
  const tagName = data?.tagName || data?.tag?.name;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Label />}
      title="Tag"
      color="#215e97"
      bgColor="#ffffff"
      isConnectable={isConnectable}
      selected={selected}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 10px",
          borderRadius: 20,
          fontSize: 11,
          fontWeight: 600,
          backgroundColor: tagName ? "#E8F0FE" : "#f5f5f5",
          color: tagName ? "#215e97" : "#999",
          border: `1px solid ${tagName ? "#215e9730" : "#e0e0e0"}`,
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <Label style={{ fontSize: 13, color: tagName ? "#215e97" : "#bbb" }} />
        {tagName || "Nenhuma tag"}
      </div>
    </NodeWrapper>
  );
});

TagNode.displayName = "TagNode";
export default TagNode;
